import Vue from 'vue';
import VueRouter from 'vue-router';

import FTSLogin from "../administration/FTSLogin";
import Client from "../../Client";
import Studio from "../../Studio";
import FTSDashboard from "../client/FTSDashboard";
import FTSCalendar from "../client/FTSCalendar";
import FTSHtmlViewer from "../client/FTSHtmlViewer";
import FTSListView from "../elements/FTSListView";
import FTSUsers from "../client/FTSUsers";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: FTSLogin
  },
  {
    path: '/join',
    name: 'join',
    component: FTSLogin
  },
  {
    path: '/activate',
    name: 'activate',
    component: FTSLogin
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: FTSLogin
  },
  {
    path: '/reset',
    name: 'reset',
    component: FTSLogin
  },
  {
    path: '/createAccount',
    name: 'createAccount',
    component: FTSLogin
  },
  {
    path: '/client',
    name: 'client',
    component: Client,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: FTSDashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/calendar',
        name: 'calendar',
        component: FTSCalendar,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/htmlViewer',
        name: 'htmlViewer',
        component: FTSHtmlViewer,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/list/:moduleId',
        name: 'list-view',
        component: FTSListView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/users',
        name: 'users',
        component: FTSUsers,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/client',
        redirect: '/dashboard'
      }
    ]
  },
  {
    path: '/studio',
    name: 'studio',
    component: Studio,
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

/* avoided redundant navigation to current location (NavigationDuplicated) */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default routes;